export default __webpack_public_path__ + "static/media/surveypanda1.8a18158a.png";